module.exports = __webpack_public_path__ + "img/imageInComment.b4ebb79e.png";